export { default as Form } from 'employees/components/form/EmployeeForm';



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/components/form/index.js